import React, { useState } from "react";
import { Grid } from "@mui/material";
import Button from "../../../../components/Button-v2";

import DadosGeraisPropostaSection from "../sections/DadosGeraisPropostaSection";
import InformacoesPessoaisEmpresariaisSection from "../sections/InformacoesPessoaisEmpresariaisSection";
import EnderecoSection from "../sections/EnderecoSection";
import InformacoesProfissionaisSection from "../sections/InformacoesProfissionaisSection";
import PessoaPoliticamenteExpostaSection from "../sections/PessoaPoliticamenteExpostaSection";
import InformacoesFinanceirasSection from "../sections/InformacoesFinanceirasSection";
import LogEstruturadoComponent from "./LogEstruturado/index";

import {
  ComponentWrapper,
  CardWrapper,
  Label,
  CardFilled,
  Card,
  ButtonWrapper,
} from "../styles";
import { toUpper } from "lodash";

const CadastroComponent = (props) => {
  const {
    cpfCnpj,
    proposalOperation = {},
    proposalOperationLoading,
    proposalCompleteRegistration = {},
    proposalCompleteRegistrationLoading,
    proposalPartnershipRegistrations = {},
    proposalPartnershipRegistrationsLoading,
    participacoesOutrasEmpresas,
    participacoesOutrasEmpresasLoading,
    clienteContas,
    clienteContasLoading,
  } = props;

  const [openPopupHistoricoCadastro, setOpenPopupHistoricoCadastro] =
    useState(false);

  return (
    <ComponentWrapper>
      <CardWrapper>
        <Label>Dados gerais da proposta</Label>
        <CardFilled>
          <DadosGeraisPropostaSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            proposalOperationLoading={proposalOperationLoading}
            numeroCpfCnpj={proposalCompleteRegistration.cpfCnpj}
            nomeCliente={proposalCompleteRegistration.nomeCliente}
            nomeConvenio={proposalCompleteRegistration.nomeConvenio}
            nomeFilial={proposalCompleteRegistration.nomeFilial}
            nomeFilialFantasia={proposalCompleteRegistration.nomeFilialFantasia}
            numeroProposta={proposalCompleteRegistration.numeroProposta}
            produto={proposalOperation.produto}
            nomeAnalista={proposalCompleteRegistration.nomeAnalista}
            descricaoStatus={proposalCompleteRegistration.descricaoStatus}
            rankingRelacionamento={
              proposalCompleteRegistration.rankingRelacionamento
            }
            sistemaOrigem={proposalCompleteRegistration.sistemaOrigem}
            pcLtvRisco={proposalCompleteRegistration.pcLtvRisco}
            pcCompRendaCliente={proposalCompleteRegistration.pcCompRendaCliente}
            idRiscoScrCliente={proposalCompleteRegistration.idRiscoScrCliente}
            idRiscoSerasaCliente={
              proposalCompleteRegistration.idRiscoSerasaCliente
            }
          />
        </CardFilled>
      </CardWrapper>

      <CardWrapper>
        <Label>
          {toUpper(proposalCompleteRegistration.tipoPessoa) === "F"
            ? "Informações Pessoais"
            : "Informações Empresa"}
        </Label>
        <Card>
          <InformacoesPessoaisEmpresariaisSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            numeroCpf={proposalCompleteRegistration.cpfCnpj}
            nomeCliente={proposalCompleteRegistration.nomeCliente}
            dataNascimentoCliente={
              proposalCompleteRegistration.dataNascimentoCliente
            }
            idadeCliente={proposalCompleteRegistration.idadeCliente}
            descricaoSexo={proposalCompleteRegistration.descricaoSexo}
            nacionalidade={proposalCompleteRegistration.nacionalidade}
            naturalidade={proposalCompleteRegistration.naturalidade}
            ufNaturalidade={proposalCompleteRegistration.ufNaturalidade}
            dataCadastro={proposalCompleteRegistration.dataCadastro}
            dataValidadeCadastro={
              proposalCompleteRegistration.dataValidadeCadastro
            }
            descricaoTipoDocumento={
              proposalCompleteRegistration.descricaoTipoDocumento
            }
            numeroDocumento={proposalCompleteRegistration.numeroDocumento}
            dataExpedicaoDocumento={
              proposalCompleteRegistration.dataExpedicaoDocumento
            }
            siglaOrgaoEmissor={proposalCompleteRegistration.siglaOrgaoEmissor}
            nomePai={proposalCompleteRegistration.nomePai}
            nomeMae={proposalCompleteRegistration.nomeMae}
            dddTelefone={proposalCompleteRegistration.dddTelefone}
            telefone={proposalCompleteRegistration.telefone}
            dddCelular={proposalCompleteRegistration.dddCelular}
            celular={proposalCompleteRegistration.celular}
            email={proposalCompleteRegistration.email}
            descricaoGrauInstrucao={
              proposalCompleteRegistration.descricaoGrauInstrucao
            }
            numeroDependentes={proposalCompleteRegistration.numeroDependentes}
            isAnalfabeto={proposalCompleteRegistration.isAnalfabeto}
            isEmancipado={proposalCompleteRegistration.isEmancipado}
            descricaoEstadoCivil={
              proposalCompleteRegistration.descricaoEstadoCivil
            }
            isUniaoEstavel={proposalCompleteRegistration.isUniaoEstavel}
            tipoPessoa={proposalCompleteRegistration.tipoPessoa}
            numeroCnpj={proposalCompleteRegistration.cpfCnpj}
            razaoSocial={proposalCompleteRegistration.nomeCliente}
            nomeFantasia={proposalCompleteRegistration.nomeClienteResumido}
            dataFundacao={proposalCompleteRegistration.dataFundacao}
            inscricaoEstadual={proposalCompleteRegistration.inscricaoEstadual}
            inscricaoMunicipal={proposalCompleteRegistration.inscricaoMunicipal}
            codigoRamoAtividade={
              proposalCompleteRegistration.codigoRamoAtividade
            }
            descricaoRamoAtividade={
              proposalCompleteRegistration.descricaoRamoAtividade
            }
            porteEmpresa={proposalCompleteRegistration.porteEmpresa}
            codigoCnae={proposalCompleteRegistration.codigoCnae}
            descricaoCnae={proposalCompleteRegistration.descricaoCnae}
            faturamentoAnual={proposalCompleteRegistration.faturamentoAnual}
            proposalPartnershipRegistrations={proposalPartnershipRegistrations}
            proposalPartnershipRegistrationsLoading={
              proposalPartnershipRegistrationsLoading
            }
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Endereço</Label>
        <Card>
          <EnderecoSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            cep={proposalCompleteRegistration.cep}
            endereco={proposalCompleteRegistration.endereco}
            enderecoNumero={proposalCompleteRegistration.enderecoNumero}
            complemento={proposalCompleteRegistration.complemento}
            bairro={proposalCompleteRegistration.bairro}
            nomeCidade={proposalCompleteRegistration.nomeCidade}
            uf={proposalCompleteRegistration.uf}
            pais={proposalCompleteRegistration.pais}
            tipoPessoa={proposalCompleteRegistration.tipoPessoa}
            email={proposalCompleteRegistration.email}
            dddTelefone={proposalCompleteRegistration.dddTelefone}
            telefone={proposalCompleteRegistration.telefone}
            dddCelular={proposalCompleteRegistration.dddCelular}
            celular={proposalCompleteRegistration.celular}
          />
        </Card>
      </CardWrapper>

      {toUpper(proposalCompleteRegistration.tipoPessoa) === "F" && (
        <CardWrapper>
          <Label>Informações Profissionais</Label>
          <Card>
            <InformacoesProfissionaisSection
              proposalCompleteRegistrationLoading={
                proposalCompleteRegistrationLoading
              }
              participacoesOutrasEmpresasLoading={
                participacoesOutrasEmpresasLoading
              }
              trabalhoNomeEmpresa={
                proposalCompleteRegistration.trabalhoNomeEmpresa
              }
              trabalhoCnpjEmpresa={
                proposalCompleteRegistration.trabalhoCnpjEmpresa
              }
              trabalhoEnderecoEmpresa={
                proposalCompleteRegistration.trabalhoEnderecoEmpresa
              }
              trabalhoCepEmpresa={
                proposalCompleteRegistration.trabalhoCepEmpresa
              }
              trabalhoNumeroEmpresa={
                proposalCompleteRegistration.trabalhoNumeroEmpresa
              }
              trabalhoComplementoEmpresa={
                proposalCompleteRegistration.trabalhoComplementoEmpresa
              }
              trabalhoBairroEmpresa={
                proposalCompleteRegistration.trabalhoBairroEmpresa
              }
              trabalhoCidadeEmpresa={
                proposalCompleteRegistration.trabalhoCidadeEmpresa
              }
              trabalhoUfEmpresa={proposalCompleteRegistration.trabalhoUfEmpresa}
              trabalhoDddTelefoneEmpresa={
                proposalCompleteRegistration.trabalhoDddTelefoneEmpresa
              }
              trabalhoTelefoneEmpresa={
                proposalCompleteRegistration.trabalhoTelefoneEmpresa
              }
              rendaBruta={proposalCompleteRegistration.rendaBruta}
              dataAdmissao={proposalCompleteRegistration.dataAdmissao}
              descricaoProfissao={
                proposalCompleteRegistration.descricaoProfissao
              }
              descricaoCargo={proposalCompleteRegistration.descricaoCargo}
              participacoesOutrasEmpresas={participacoesOutrasEmpresas}
            />
          </Card>
        </CardWrapper>
      )}

      {toUpper(proposalCompleteRegistration.tipoPessoa) === "F" && (
        <CardWrapper>
          <Label>PEP</Label>
          <Card>
            <PessoaPoliticamenteExpostaSection
              proposalCompleteRegistrationLoading={
                proposalCompleteRegistrationLoading
              }
              isPoliticamenteExposto={
                proposalCompleteRegistration.isPoliticamenteExposto
              }
              isParentePoliticamenteExposto={
                proposalCompleteRegistration.isParentePoliticamenteExposto
              }
            />
          </Card>
        </CardWrapper>
      )}

      <CardWrapper>
        <Label>Informações financeiras</Label>
        <Card>
          <InformacoesFinanceirasSection
            clienteContasLoading={clienteContasLoading}
            clienteContas={clienteContas}
          />
        </Card>
      </CardWrapper>
      <Grid container spacing={0}>
        <Grid item md={10} />
        <Grid item md={2}>
          <ButtonWrapper margin="5rem 0 0 1rem">
            <Button
              height="40px"
              minWidth="240px"
              fontSize="11px"
              type="button"
              onClick={() => setOpenPopupHistoricoCadastro(true)}
            >
              Consultar histórico de cadastro
            </Button>
          </ButtonWrapper>
        </Grid>
      </Grid>

      {!openPopupHistoricoCadastro ? (
        <></>
      ) : (
        <LogEstruturadoComponent
          cpfCnpj={cpfCnpj}
          setOpenPopup={setOpenPopupHistoricoCadastro}
        />
      )}
    </ComponentWrapper>
  );
};

export default CadastroComponent;
